// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Sc-d","cell":"ColumnAccessor_cell__34M3S","firstCellAccent":"ColumnAccessor_firstCellAccent__39ZA8"};